module.exports = __webpack_public_path__ + "media/images/icons/icon-filter-1ce9da99b2a01c5affc13783faa06508.svg";